import {
  PntAppControllerGetScreenbugByDate200,
  PntScreenbugSegments,
  PntScreenbugSegmentsResponseDTO,
} from '@mi-front/api-v2';
import { DateTimeStr, toDateTimeStr } from '@mi-front/core';
import { ScreenbugResponseType } from './types';

/**
 * OpenAPI models a single segment union; the endpoint returns an array at runtime.
 */
function asScreenbugItems(
  data:
    | PntAppControllerGetScreenbugByDate200
    | PntAppControllerGetScreenbugByDate200[]
    | null
    | undefined,
): Array<PntScreenbugSegmentsResponseDTO | PntScreenbugSegments> {
  if (!data) {
    return [];
  }

  return (Array.isArray(data) ? data : [data]) as Array<
    PntScreenbugSegmentsResponseDTO | PntScreenbugSegments
  >;
}

/**
 * Normalizes api-v2 screenbug payloads into absolute `from`/`to` string ranges.
 */
export function normalizeScreenbugByDateResponse(
  data:
    | PntAppControllerGetScreenbugByDate200
    | PntAppControllerGetScreenbugByDate200[]
    | null
    | undefined,
): ScreenbugResponseType[] {
  return asScreenbugItems(data).map((item) => {
    if ('from' in item && 'to' in item) {
      return {
        screen_bug: item.screen_bug,
        from: item.from as DateTimeStr,
        to: item.to as DateTimeStr,
      };
    }

    return {
      screen_bug: item.screen_bug,
      from: toDateTimeStr(item.start),
      to: toDateTimeStr(item.end),
    };
  });
}
